import React from "react";
import { createRoot } from "react-dom/client";
import { createStore, combineReducers } from "redux";
import { Provider } from "react-redux";
import $ from "jquery";

import { initCards } from "../../cards";
import initSlides from "../../slide_decks/add_to_slide_deck";
import initPrint from "../../print_links";
import initPermalink from "../../permalink_modal";
import ForecastsFiltersContainer from "./containers/forecasts_filters_container";
import ForecastsTableContainer from "./messy/forecasts_table_container";
import filterReducer from "./reducers/filters";

class ForecastsFiltersApp {
  constructor(htmlNode, propsAndState) {
    const store = createStore(
      combineReducers({
        filters: filterReducer
      }),
      propsAndState.serverState,
      window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

    this.store = store;

    const wrapApp = (AppComponent, reduxStore) =>
    <Provider store={reduxStore}>
      <AppComponent {...propsAndState.props} />
    </Provider>;

    createRoot(htmlNode).render(wrapApp(ForecastsFiltersContainer, store));
  }

  initializeTable = (tableData) => {
    const table = $("#main-container .data-hub-table-container .compact-table");

    const tableContainerNode = table.find(".forecasts-table-container")[0];
    if (tableData && tableContainerNode) {
      // React 18: one root per node. responseFromServer unmounts before replacing
      // the DOM, but guard here too so a stray re-init can't double-createRoot.
      if (this.tableRoot) { this.tableRoot.unmount(); }
      this.tableRoot = createRoot(tableContainerNode);
      this.tableRoot.render(<ForecastsTableContainer tableData={tableData.rows} extraTotalRow={tableData.extra_total_row} sevenYearRange={tableData.seven_year_range} startYearHeading={tableData.start_year_heading} showDisclaimer={tableData.show_disclaimer} />);
    } else {
      // eslint-disable-next-line no-console
      console.log("There was an error loading forecast filter app table data.");
    }
  }

  responseFromServer = (props, html, noResults) => {
    const oldChart = window.Highcharts.charts[0];
    if (oldChart) oldChart.destroy();
    window.Chartkick.charts = [];
    const forecastMainContainer = $("#main-container .data-hub-table-container");
    // The table root is torn down before its node is destroyed by the innerHTML swap below.
    if (this.tableRoot) { this.tableRoot.unmount(); this.tableRoot = null; }
    // This is what loads the new card HTML into the page.
    forecastMainContainer[0].innerHTML = html;
    // $("#main-container .data-hub-table-container .compact-table").html(html); this is 5 seconds slower
    // on windows chrome. for some reason.
    if (noResults) {
      forecastMainContainer.find(".card-body").html("<h3>No results for the filter combination selected.</h3>");
    } else {
      const script = forecastMainContainer.find("script").text();
      // Indirect eval: run the injected card <script> text in global scope (as a real <script> tag
      // would), not this function's scope. Also avoids esbuild's direct-eval bundling warning.
      (0, eval)(script);
    }

    const refresh = () => {
      initCards();
      initSlides();
      initPrint();
      initPermalink();
      $(window).trigger("resize");
    };

    refresh();
  }
}

export default ForecastsFiltersApp;
